import { useMutation, useQueryClient } from '@tanstack/react-query';

import { organizationServices } from '@hero/services';

export const useUpdateBranding = options => {
  const queryClient = useQueryClient();

  return useMutation(formData => organizationServices.setBranding(formData), {
    onSuccess: data => {
      queryClient.setQueryData(['branding'], () => data);
      queryClient.invalidateQueries({ queryKey: ['branding'] });
    },
    ...options
  });
};
